import React, { useEffect, lazy, useState } from 'react';
import { Row, Col, Card, Table, Spin, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import _ from "lodash";

import { RecordViewWrapper } from './Style';
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import {
  pacienteListAction
} from '../../../redux/clinica/pacientes/actionCreator';
import { render } from 'less';
const PacienteView = lazy(() => import('./Paciente'));

const PacientesViewPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.PacienteReducer.data);
  const totalPacientesOrganizacion = useSelector(state => state.PacienteReducer.totalPacientesOrganizacion);
  const [pacientes, setPacientes] = useState([]);
  const [paramSearch, setParamSearch] = useState('');

  useEffect(() => {
    if (pacienteListAction) {
      dispatch(pacienteListAction());
    }
  }, [dispatch]);

  useEffect(() => {
    if (paramSearch) {
      let result = _.chain(registros)
        .groupBy("sucursal")
        .toPairs()
        .map(function (currentData) {
          return _.zipObject(["sucursal", "pacientes"], currentData);
        })
        .value();
      setPacientes(result);
    }
    else {
      setPacientes(registros);
    }
  }, [registros]);

  const dataSource = [];

  const onHandleSearch = e => {
    if (e.target.value.length % 3 == 0) { // buscar cada que se introducen 3 letras para evitar multiples llamadas al API
      dispatch(pacienteListAction(e.target.value));
      setParamSearch(e.target.value);
    } 
  };

  const renderTitle = (sucursalInfo) => {
    if (sucursalInfo.total_pacientes) {
      return <>{sucursalInfo.sucursal.toString().toUpperCase() + ' (' + sucursalInfo.total_pacientes + ' pacientes activos)'}</>
    } else {
      return <>{sucursalInfo.sucursal.toString().toUpperCase()}</>
    }



  }

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/clinica/pacientes/form">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nuevo paciente</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        ghost
        title="PACIENTES"
      />
      <Main>
        <p style={{ textAlign: 'right' }}>
          <small>
            {paramSearch ? '' : 'Últimos 4 pacientes registrados en cada sucursal.'}
            {' '}
            {
              paramSearch ? '' : <span>
                {totalPacientesOrganizacion} pacientes registrados en la organización.
              </span>
            }

          </small>
        </p>
        {pacientes.map(elemento => {
          return (
            <Card size="small" title={renderTitle(elemento)} style={{ width: '100%', marginBottom: '1em' }}>
              <Row gutter={[16, 16]}>
                {elemento?.pacientes.length > 0 && elemento?.pacientes.map((registro, index) => {
                  if (index <= 3)
                    return (
                      <Col span={6}>
                        <PacienteView registro={registro} />
                      </Col>
                    );
                })}
              </Row>
            </Card>
          );
        })}
      </Main>
    </RecordViewWrapper>
  );
};

export default PacientesViewPage;
